export default "__VITE_ASSET__DUsSmNAH__"